/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-08 15:28:00
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-07 11:43:40
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Popover/Popover.tsx
 */
import React from 'react';
import { Popover } from 'antd';

interface IProps {
  overlay;
  children;
  placement?;
  onVisibleChange?;
  visible?;
  className?;
  trigger?;
  title?;
  overlayClassName?: string;
  id?: string;
}
const PopOver = (props: IProps) => {
  const { overlay, children, placement, title, overlayClassName, id, ...rest } =
    props;

  return (
    <Popover
      content={overlay}
      title={title}
      overlayClassName={overlayClassName}
      placement={placement}
      // getPopupContainer={(trigger) => trigger}
      getPopupContainer={() => {
        if (id) {
          return document.getElementById(id);
        }
        return document.body;
      }}
      {...rest}>
      {children}
    </Popover>
  );
};
export default PopOver;
